import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { LoyaltyBenefitResponse } from '@pegasus/plus';
import camelcaseKeys from 'camelcase-keys-all-env';
import { fetchCustomerAction } from '../actions';
import { State } from '../state';

const initialState: State['loyalty'] = {
    status: null,
    tier: null,
    points: {
        totalPoints: 0,
        availablePoints: 0,
        pendingPoints: 0,
        pointsUntilNextTier: 0,
    },
};

export const reducer = reducerWithInitialState<State['loyalty']>(initialState).case(
    fetchCustomerAction.done,
    (state, { result }) => {
        const { loyalty } = result;
        return {
            ...state,
            ...loyalty,
            points: {
                totalPoints: loyalty.points.total_points,
                availablePoints: loyalty.points.available_points,
                pendingPoints: loyalty.points.pending_points,
                pointsUntilNextTier: loyalty.points.points_until_next_tier,
            },
            benefits: camelcaseKeys(loyalty?.benefits || [], {
                deep: true,
            }) as unknown as LoyaltyBenefitResponse[],
        };
    },
);

export default reducer;
